import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';
import { formatParam } from 'utils/formatParam';
import { formatPos } from 'utils/pos';
import { ProductType } from './notebooks';

export type TravelDataOptions = {
  market_id?: number;
  wines?: string[];
  brands?: string[];
  productType?: ProductType;
};

export const useTravelData = (options: TravelDataOptions) => {
  const { isLoading, data } = useTypedQuery('get', '/travel/data', {
    params: {
      query: {
        market_id: options.market_id,
        wines: formatParam(JSON.stringify(options.wines)),
        brands: formatParam(JSON.stringify(options.brands)),
        product_type: formatParam(options.productType)
      }
    }
  });

  const dataPos = data?.pos || [];

  return {
    isLoading,
    availableMarkets: data?.available_markets || [],
    selectedMarket: data?.selected_market || null,
    pos: dataPos.map((item) => formatPos(item)),
    ranks: data?.ranks || [],
    history: data?.history || [],
    wineKpi: data?.wine_kpi || [],
    brandKpi: data?.brand_kpi || [],
    clientWines: data?.client_wines || [],
    clientBrands: data?.client_brands || []
  };
};

export const useTravelPOSRefs = (options: TravelDataOptions) => {
  const { isLoading, data } = useTypedQuery('get', '/travel/pos_refs', {
    params: {
      query: {
        market_id: options.market_id,
        wines: formatParam(JSON.stringify(options.wines)),
        brands: formatParam(JSON.stringify(options.brands)),
        product_type: formatParam(options.productType)
      }
    }
  });

  return {
    isLoading,
    pos: data?.pos || []
  };
};
